module.exports = __webpack_public_path__ + "img/avatar-app-72x72.9e6594df.png";